import React, { useContext, useEffect, useState, useCallback } from "react";
import { Avatar, Button, Pane, Select, Text, toaster } from "evergreen-ui";
import ControlHubContext from "../contexts/controlhub";
import logo from "../assets/images/logo.png";
import useControlHub from "../hooks/useControlHub";
import { APP_URL } from "../config";

function HeaderApp({ companies, onChangeCompany }) {
  const { api } = useControlHub();
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const { cookieSession, currentCompanyId, currentCompanyInfo, isSuperuser } =
    useContext(ControlHubContext);

  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        setLoading(true);
        const { answer, success, message } = await api.getCurrentUser();
        if (!success) {
          throw new Error(message);
        }
        setUserData(answer);
      } catch (error) {
        toaster.danger(error?.message || "Unable to retrieve user data");
      }
      setLoading(false);
    };
    api?.isReady && cookieSession && getCurrentUser();
  }, [api, cookieSession]);

  const handleLogout = useCallback(async () => {
    try {
      const response = await api.getLogout();
      const { success, message } = response;
      if (!success) {
        throw new Error(message);
      }
    } catch (error) {
      toaster.danger(error?.message);
    }
    window.location.href = `${APP_URL}/`;
  }, [api]);

  if (loading || !cookieSession) {
    return <Pane />;
  }

  return (
    <Pane
      display="flex"
      padding={8}
      borderBottom
      background="white"
      justifyContent="space-between"
    >
      <Pane flex={1} alignItems="center" display="flex" maxWidth={400}>
        <img src={logo} alt="ControlHub" className="controlhub-logo" />
        {isSuperuser ? (
          <Select
            width={100}
            marginLeft={36}
            value={currentCompanyId === null ? "" : currentCompanyId}
            onChange={(event) => {
              onChangeCompany(event.target.value);
            }}
          >
            {companies.map((company, index) => (
              <option value={company.id} key={`company-${index}`}>
                {company.name}
              </option>
            ))}
          </Select>
        ) : (
          <Text marginLeft={36}>{currentCompanyInfo.name || ""}</Text>
        )}
      </Pane>
      <Pane alignItems="center" display="flex">
        <Avatar
          marginRight={16}
          src={userData?.image_48}
          name={userData?.full_name}
          size={30}
        />
        <Button appearance="primary" onClick={handleLogout}>
          Logout
        </Button>
      </Pane>
    </Pane>
  );
}

export default HeaderApp;
